const localization = {
  DECIMAL_SEPARATOR: ",",
};

export default localization;
